module.exports = __webpack_public_path__ + "assets/img/social/facebook-icon.84b2f9bf356d2149b2fa8e87b86e4cfb.svg";